<template>
    <div :class="twMerge('animate-pulse rounded-2 bg-disabled w-full', props.class)" />
</template>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { twMerge } from 'tailwind-merge'

interface SkeletonProps {
    class?: HTMLAttributes['class']
}

const props = defineProps<SkeletonProps>()
</script>
